var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"/web/viewer.html?file=%2Fhttps://sims2hardt.blob.core.windows.net/documentation/d733755dd6c446ae9d1c09dae080ae9b-Blaze.pdf"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-080c5918","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/app/technicaldocumentation/components/PDFPage.vue
// module id = 4ffL
// module chunks = 1